import React, { useMemo, useState } from 'react'
import { Button, List, ListItem, ListItemIcon, ListItemText, makeStyles, Theme } from '@material-ui/core';
import FolderIcon from "@material-ui/icons/Folder";
import LibraryBooksIcon from "@material-ui/icons/LibraryBooks";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";

import { LibraryItem } from '../../../../entities/LibraryItem';
import { LibraryItemType } from '../../../../entities/LibraryItemType';
import { useLibrary } from '../../LibraryPage';

const useStyles = makeStyles((theme: Theme) => ({
    moveContentFolders: {
        overflowX: "hidden",
        maxHeight: 200,
        height: "calc(100% - 29px)",
        overflowY: "auto",
        [theme.breakpoints.down("sm")]: {
            maxHeight:"90%",
            height: "90%"
        }
    },
    moveListItemMoveArrow: {
        display: "none",
        color: "rgb(143, 143, 143)",
    },
    moveListItem: {
        cursor: "default",
        padding: "2px",
        userSelect: "none",
        fontSize: "13px",
        overflow: "hidden",
        position: "relative",
        outline: "none",
        textAlign: "left",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        "&:hover": {
            backgroundColor: "rgba(143, 143, 143, .1)",
            "& svg:last-of-type": {
                display: "inline-block",
            },
        },
    },
    moveListItemIcon: {
        color: "rgb(143, 143, 143)",
        marginRight: "0px",
        marginLeft: "8px",
    },
    moveHereActionContainer: {
        height: "29px",
        padding: "16px",
        borderTop: "1px solid #F3F3F3",
        [theme.breakpoints.down("sm")]: {
            height: "10%",
        }
    },
    moveHereActionButton: {
        display: "inline-block",
        maxWidth: "150px",
        verticalAlign: "bottom",
        borderRadius: 0,
    },
    moveListItemText: {
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        "& span": {
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
        },
    },
    selected: {
        backgroundColor: `${theme.palette.primary.main} !important`,
        "&:hover": {
            backgroundColor: "#4d90fe",
        },
        "& span": {
            color: "#FFF",
        },
    },
}));

interface MoveMenuFolderListProps {
    handleClickIntoFolder: (assetId:string) => void;
    handleMove: (newParentId:string | undefined) => void;
    disabled: boolean;
    itemToMove: LibraryItem;
    currentFolderId: string | undefined;
}

export function MoveMenuFolderList(props:MoveMenuFolderListProps){
    const { disabled, itemToMove, currentFolderId} = props
    const context = useLibrary();
    const classes = useStyles();
    const [focusedItemId, setFocusedItemId] = useState<string | undefined>()
    const currentFolders = useMemo(() => 
        context.libraryItems.filter(i => i.parentId === currentFolderId && (i.type === LibraryItemType.Folder || i.type === LibraryItemType.SermonSeries))
    // eslint-disable-next-line react-hooks/exhaustive-deps
    , [context.libraryItems, props.currentFolderId])

    
    return (
        <div style={{height: "100%"}}>
                <div className={classes.moveContentFolders}>
                    { currentFolders.length > 0 
                    ?
                    <List component="nav">
                            {currentFolders.map((item: LibraryItem) => {
                                return (
                                    <ListItem
                                    button
                                    key={item.id}
                                    className={classes.moveListItem}
                                    disabled={itemToMove.id === item.id || disabled }
                                    onDoubleClick={() => props.handleClickIntoFolder(item.id)}
                                    onClick={() => setFocusedItemId(item.id)}
                                    selected={focusedItemId === item.id}
                                    classes={{ selected: classes.selected }}
                                    >
                                        <ListItemIcon
                                            className={classes.moveListItemIcon}
                                            style={{color: focusedItemId === item.id ? "#FFF" : undefined}}
                                        >
                                            {item.type === LibraryItemType.Folder
                                            ? <FolderIcon fontSize="small" />
                                            : <LibraryBooksIcon fontSize="small" style={{color: "#7627bb"}} />
                                        }
                                        </ListItemIcon>
                                        <ListItemText primary={item.name} className={classes.moveListItemText} />
                                        <ChevronRightIcon
                                            className={classes.moveListItemMoveArrow}
                                            fontSize="small"
                                            style={{
                                                color: "rgb(143, 143, 143)",
                                                display: "inherit",
                                            }}
                                            onClick={() => props.handleClickIntoFolder(item.id)}
                                            />
                                    </ListItem>
                                );
                            })}
                        </List>
                    :
                    <div
                            style={{
                                textAlign: "center",
                                marginTop: "30%",
                                fontFamily: "Roboto,Arial,sans-serif",
                                color: "#777",
                                fontSize: "13px",
                            }}
                            >
                            This folder has no folders
                        </div>
                    }
                </div>
                <div className={classes.moveHereActionContainer}>
                    <Button
                        variant="contained"
                        size="medium"
                        color="primary"
                        className={classes.moveHereActionButton}
                        disabled={(disabled || itemToMove.parentId === currentFolderId) && focusedItemId === undefined}
                        onClick={() => props.handleMove(focusedItemId ?? currentFolderId)}
                        >
                        Move Here
                    </Button>
                </div>
        </div>
    )
}